import Attachment from 'models/attachment';
import { createContentModel, isEmpty } from './composition_content_shared';
import { prop } from 'models/lib/create_model';

const ThirdPartyEmailCompositionContent = createContentModel({
  modelName: 'ThirdPartyEmailCompositionContent',

  properties: {
    bcc: String,
    bodyHtml: String,
    cc: String,
    dueAt: String, // follow-up date for the task that will hold the thread
    from: String,
    headers: Object,
    inlineAttachments: prop([Attachment]).default([]),
    subjectHtml: String,
    to: String,
  },

  setRecipients({ tos, ccs, bccs }) {
    this.to = tos.join(', ');
    this.cc = ccs.join(', ');
    this.bcc = bccs.join(', ');
  },

  setFrom(from) {
    this.from = from;
  },

  addInlineAttachments(inlineAttachments) {
    this.inlineAttachments = this.inlineAttachments.concat(inlineAttachments);
  },

  isEmpty() {
    return isEmpty(this.bodyHtml);
  },

  getHeader(key) {
    return this.headers && this.headers[key];
  },
});

ThirdPartyEmailCompositionContent.MAX_SINGLE_ATTACHMENT_SIZE_MB = 15;

export default ThirdPartyEmailCompositionContent;
